      // mega menu
      document.addEventListener('DOMContentLoaded', function(){

      const categories = document.querySelectorAll('.mega-category');

      categories.forEach(function(item){

        item.addEventListener('mouseenter', function(){

          const target = this.dataset.target;

          document.querySelectorAll('.mega-category').forEach(function(el){
            el.classList.remove('active');
          });

          this.classList.add('active');

          document.querySelectorAll('.submenu-panel').forEach(function(el){
            el.classList.remove('active');
          });

          const panel = document.querySelector(
            '.submenu-panel[data-panel="' + target + '"]'
          );

          if(panel){
            panel.classList.add('active');
          }

        });

      });

    });


    document.querySelectorAll('.mega-category').forEach(function(item){

  item.addEventListener('mouseenter', function(){

    let target = this.dataset.target;

    document.querySelectorAll('.mega-category').forEach(function(el){
      el.classList.remove('active');
    });

    this.classList.add('active');

    document.querySelectorAll('.product-panel').forEach(function(el){
      el.classList.remove('active');
    });

    let panel = document.querySelector(
      '.product-panel[data-product-panel="' + target + '"]'
    );

    if(panel){
      panel.classList.add('active');
    }

  });

});

// mobile menu
document.querySelectorAll('.site-nav-dropdown-detail summary').forEach(summary => {

  summary.addEventListener('click', function () {

    const details = this.closest('.site-nav-dropdown-detail');

    setTimeout(() => {
      details.setAttribute('open', true);
    }, 10);

  });

});

document.querySelectorAll('.menu-back').forEach(btn => {

  btn.addEventListener('click', function (e) {

    e.preventDefault();

    const details = this.closest('.site-nav-dropdown-detail');

    details.removeAttribute('open');

  });

});